<template>
  <v-app :style="getBg">
    <v-app-bar app color="primary" dark>
      <div class="d-flex align-center">
        <span
          @click="$router.push('/' + $i18n.locale)"
          style="cursor:pointer"
          class="title"
          >{{ $t("nav.app_name") }}</span
        >
        <!-- <v-img src="http://www.maxisu.com/images/logo.png" max-width="270" max-height="60"></v-img> -->
      </div>

      <!-- <v-btn @click="removeFromCart"  class="mr-10" color="secondary">
        <v-icon left>mdi-cart</v-icon> Remove From Cart
      </v-btn>-->
      <!-- <v-alert type="warning" dense class="ml-10"> {{ $t('test') }} </v-alert> -->
      <v-spacer></v-spacer>
      <!-- v-on:keyup.enter="queryPumps" -->
      <!-- v-model="query.hm" -->

      <v-dialog v-if="token" v-model="showDiscountDialog" max-width="300px">
        <template v-slot:activator="{ on }">
          <v-btn class="mx-4" color="secondary" v-on="on">
            {{ discountFromAPI }}%
            {{ $t("discount") }}
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">{{ $t("changeDiscount") }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="discountInput"
                    :label="$t('discount')"
                    append-icon="mdi-percent"
                    type="number"
                    min="0"
                    max="100"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="onTapCloseDiscount">{{
              $t("cancel")
            }}</v-btn>
            <v-btn text @click="saveDiscount" class="primary">{{
              $t("save")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-btn
        v-if="token"
        @click="gotoCart"
        rounded
        large
        class="mr-10"
        color="secondary"
      >
        <v-icon left>mdi-cart</v-icon>
        {{ $t("cart.title") }}
      </v-btn>

      <!-- v-if="!$route.path.endsWith('/cart')" -->

      <span v-if="username" class="ml-8 mr-4"
        >{{ $t("welcome") }} {{ username }}</span
      >
      <v-btn id="logout" class="mr-4" v-if="token" @click="logout" text>
        <span class="mr-2">{{ $t("nav.logout") }}</span>
        <v-icon>mdi-exit-to-app</v-icon>
      </v-btn>

      <v-menu top>
        <template v-slot:activator="{ on }">
          <v-btn class="mr-4 ml-8" color="secondary" icon dark v-on="on">
            <v-img
              class="mr-2"
              :src="`/${$i18n.locale}.svg`"
              max-width="40"
              max-height="40"
            ></v-img>
            <span class style="color:#FFF">{{
              $i18n.locale.toUpperCase()
            }}</span>
          </v-btn>
        </template>

        <v-list>
          <v-list-item
            v-for="(item, index) in $i18n.availableLocales"
            :key="index"
            @click="setLang($i18n.availableLocales[index])"
          >
            <v-list-item-avatar>
              <v-img :src="`/${item}.svg`"></v-img>
            </v-list-item-avatar>
            <v-list-item-title>{{ item.toUpperCase() }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <!-- {{ $i18n.locale.toUpperCase() }} 
      <v-img class="ml-2" :src="`/${$i18n.locale}.png`" max-width="40" max-height="40"></v-img>-->

      <!-- <v-menu
      v-model="$i18n.locale" 
      :close-on-click="true" 
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="primary"
          dark
          v-on="on"
        >
          {{ $i18n.locale.toUpperCase() }} 
        </v-btn>
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in langs"
          :key="index"
          @click="$i18n.locale=langs[index].title"
        >
          <v-list-item-title>{{ item.title.toUpperCase() }}</v-list-item-title>
        </v-list-item>
      </v-list>
      </v-menu>-->

      <!-- <v-btn href="https://github.com/vuetifyjs/vuetify/releases/latest" target="_blank" text>
        <span class="mr-2">Latest Release</span>
        <v-icon>mdi-open-in-new</v-icon>
      </v-btn>-->
    </v-app-bar>

    <!-- <v-container>
      <v-content>
        <v-tabs>
          <v-tab @click="$router.push('/')">Performanslar</v-tab>
          <v-tab @click="$router.push('/')">Pumps</v-tab>
          <v-tab @click="$router.push('/motor')">Motors</v-tab>
        </v-tabs>
      </v-content>
    </v-container>-->
    <v-container>
      <v-content style="padding-top:40px"></v-content>
    </v-container>

    <v-snackbar
      :color="snackbarColor"
      top="top"
      v-model="snackbar"
      :timeout="timeout"
      >{{ msg }}</v-snackbar
    >

    <router-view @update:count="updateCount"></router-view>
  </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import Vue from "vue";
import { checkLogin, handleServerError } from "./components/utils.js";

export default {
  name: "App",
  computed: {
    getBg() {
      // console.log(this)
      if (this.$route.path.length < 6)
        return "background-image:url('/maxibg.jpg')";
      else
        return "background-blend-mode: lighten;background-color: rgba(200,200,200,0.4);background-image:url('/maxibg.jpg')";
    },
  },
  components: {
    // HelloWorld,
  },

  data: () => ({
    langs: ["en", "tr"],
    admin: false,
    token: null,
    discountInput: "",
    discountFromAPI: "",
    showDiscountDialog: false,
    username: "",
    cart: [],
    cartItemCount: 0,
    msg: "",
    snackbar: false,
    snackbarColor: "success",
    timeout: 2000,

    //
  }),

  created: function() {
    try {
      this.cart = JSON.parse(Vue.ls.get("cart", []));
      Vue.ls.on("cart", this.cartChanged);
    } catch (e) {
      this.cart = [];
      Vue.ls.on("cart", this.cartChanged);
    }
  },

  mounted: function() {
    if (localStorage.selectedLang) {
      this.$i18n.locale = localStorage.selectedLang;
    }

    if (localStorage.admin) {
      this.admin = localStorage.admin;
    }
    if (localStorage.username) {
      this.username = localStorage.username;
    }
    if (localStorage.token) {
      this.token = localStorage.token;
    }
    if (localStorage.discountFromAPI) {
      this.discountFromAPI = localStorage.discountFromAPI;
    }

    //aaa
    this.setTitle();
    // this.getDiscount();
    // alert('get username')
  },
  watch: {
    admin(newValue) {
      localStorage.admin = newValue;
    },
    token(newValue) {
      localStorage.token = newValue;
      this.getDiscount();
    },
    username(newValue) {
      localStorage.username = newValue;
    },
    showDiscountDialog(newValue) {
      if (newValue) {
        this.discountInput = this.discountFromAPI;
      }
    },
  },
  methods: {
    setTitle: function() {
      document.title = this.$t("nav.app_name");
    },
    getDiscount: function() {
      this.$http({
        method: "get",
        url: this.$API_URL + "discount",
      })
        .then((response) => {
          this.discountFromAPI = response.data.discount;
          localStorage.discountFromAPI = this.discountFromAPI;
        })
        .catch(function(error) {
          handleServerError(error);
          console.log(error);
        });
    },
    updateCount: function() {
      alert("geldi");
    },
    initLocalStorageCart: function() {
      try {
        this.cart = JSON.parse(this.$ls.get("cart", []));
        this.$ls.on("cart", this.cartChanged);
      } catch (e) {
        alert(e);
        this.cart = [];
        this.$ls.on("cart", this.cartChanged);
      }
    },
    cartChanged: function(val, oldVal, uri) {
      console.log("cart changed -- pumpreport.vue");
      try {
        if (val.length > oldVal.length) {
          this.msg = "Added to cart";
          this.snackbar = true;
        }

        this.cart = JSON.parse(val);
      } catch (e) {
        this.cart = [];
      }
    },
    removeFromCart: function() {
      this.cart.splice(0, 1);
      this.saveOrders();
    },
    saveOrders: function() {
      const parsed = JSON.stringify(this.cart);
      Vue.ls.set("cart", parsed);
      console.log("saved from app.vue");
    },
    // cartChanged: function(val, oldVal, uri) {
    //   console.log("changed from app.vue");
    //   try {
    //     this.cart = JSON.parse(val);
    //   } catch (e) {
    //     this.cart = [];
    //   }
    // },
    gotoCart: function() {
      // this.$router.push("/"+this.$i18n.locale+'/cart')

      // window.location = "/"+this.$i18n.locale+"/cart"
      this.$router.push("/" + this.$i18n.locale + "/cart");
    },
    // onTapDiscount: function() {
    //   this.showDiscountDialog = true;
    // },
    onTapCloseDiscount: function() {
      this.showDiscountDialog = false;
      this.refresh();
    },
    saveDiscount: function() {
      this.showDiscountDialog = false;

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "discount",
        data: { discount: this.discountInput },
      })
        .then((response) => {
          this.refresh();
        })
        .catch(function(error) {
          alert(this.$t("failedToChangeDiscount"));
        });
    },
    setLang: function(item) {
      this.$i18n.locale = item;
      localStorage.selectedLang = item;
      this.$router.push({ params: { lang: item } });
      this.setTitle();
      if (this.$route.path.includes("pump_report")) document.location.reload();
    },
    reload: function() {
      document.location = "/";
      // document.location.reload()
    },

    refresh: function() {
      this.$router.go();
    },

    logout: function() {
      // localStorage.removeItem("token");
      // localStorage.removeItem("admin");
      // localStorage.removeItem("username");
      // this.reload();

      this.$http({
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        url: this.$API_URL + "logout",
      })
        .then((response) => {
          localStorage.removeItem("token");
          localStorage.removeItem("admin");
          localStorage.removeItem("username");
          window.location = "/";
          // this.getCart();
        })
        .catch(function(error) {
          alert(error);
          handleServerError(error);
          console.log(error);
        });
    },
  },
};
</script>
